export default __webpack_public_path__ + "static/media/Icons_History_LightGrey Icon.5ce59405.svg";